import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class FeatureService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async featureGet(data) {
        const pos = getPosition();
        const response = await API.service('featureCustomerGet', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async featureRemove(data) {
        const pos = getPosition();
        const response = await API.service('featureCustomerRemove', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async featureList(data) {
        const pos = getPosition();
        const response = await API.service('featureList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async featureAssign(data) {
        const pos = getPosition();
        const response = await API.service('featureCustomerAssign', data, pos, this.changeAlert, null, null);

        return response?.data
    }

}